import { render, staticRenderFns } from "./mySellersSellerHistory.vue?vue&type=template&id=64a13af5&scoped=true&lang=html&"
import script from "./mySellersSellerHistory.vue?vue&type=script&lang=js&"
export * from "./mySellersSellerHistory.vue?vue&type=script&lang=js&"
import style0 from "./mySellersSellerHistory.vue?vue&type=style&index=0&id=64a13af5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a13af5",
  null
  
)

export default component.exports